import { forwardRef } from 'react'

import type { Props as BasicMultiSelectInputProps } from '../../Basic/MultiSelectInput'
import type { ReactElement, ReactNode } from 'react'
import type { Props as SelectProps } from 'react-select'

import BasicMultiSelectInput from '../../Basic/MultiSelectInput'
import Wrapper from '../Wrapper'

interface Props extends BasicMultiSelectInputProps {
  error?: ReactNode
}

const MultiSelectInput = forwardRef(({ className, error, ...props }: Props & SelectProps): ReactElement => {
  return (
    <Wrapper className={className} error={error}>
      <BasicMultiSelectInput {...props} />
    </Wrapper>
  )
})

MultiSelectInput.displayName = 'MultiSelectInput'

export default MultiSelectInput
